import React from 'react';
import { ServiceAuth } from '../../services/service-auth';
import appState from '../../state/AppStateContainer';
import _ from 'lodash';
import { withTranslation, Trans } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BtButton from '../bt-button/bt-button';

import './app-login.css';
import AppLabel from '../app-label/app-label';
import { ReactComponent as Logo } from '../../assets/images/aceve/accurator_dark.svg';
import SignInWithMicrosoft from '../../assets/svg/sign-in-with-microsoft.svg';

import { ServiceUser } from '../../services/service-user';

import styles from './app-login.module.scss';
import appEnum from '../../util/appEnum';


export class AppLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnLoginLoaderShow: false,
      errorShow: false,
      error: '',
      isM3: false,
      isBrixly: false,
    };
    this.elEmail = React.createRef();
    this.elPassword = React.createRef();
  }
  modalForgotPassword = this.props.modalForgotPassword;

  componentWillLoad() {
    if (ServiceAuth.isLoggedIn) {
      this.history.replace('/');
    }
  }

  componentDidMount() {
    this.bind();
  }

  componentDidUnload() {
    this.unbind();
  }

  bind() {
    this.unbind();
    document.addEventListener('keydown', this.documentKeydownCallback);
  }

  unbind() {
    document.removeEventListener('keydown', this.documentKeydownCallback);
  }

  documentKeydownCallback = e => {
    if (e.keyCode == 13) {
      this.login();
    }
  };

  setTokenAndRedirect = async data => {
    const urlToRedirect = appState.loadString('urlToRedirect');
    if (urlToRedirect) {
      const paths = urlToRedirect.split('/');
      const orgExist = data?.organizationData?.find(o => o.slug == paths[1]);
      const isSuperAdmin = data?.userData?.role == appEnum.Role.SuperAdmin;

      localStorage.removeItem('urlToRedirect');
      if (orgExist || isSuperAdmin) {
        await appState.setToken(data);
        window.location.href = urlToRedirect;
        return;
      }
    }
    await appState.setToken(data, true);
  };


   login = async () => {
    try {
      if (this.state.btnLoginLoaderShow) {
        return;
      }
      var email = this.elEmail.current.value;
      var password = this.elPassword.current.value;

      this.setState({ btnLoginLoaderShow: true, errorShow: false });
      let data = await ServiceAuth.login(email, password);

      if (data) {
        let token = data.userData;
        this.setState({ btnLoginLoaderShow: false, errorShow: false });

        if (_.get(this, 'props.location.state.from')) {
          token = { ...token, route: _.get(this, 'props.location.state.from') };
          this.props.location.state.from = undefined;
        }

        appState.setState({loader: true});
        await this.setTokenAndRedirect(data);

        const [, slugFromUrl] = window.location.pathname.split('/');
        const hasAccessToOrgSlug = await ServiceUser.hasAccessToSlug(token.id, slugFromUrl);

        if (hasAccessToOrgSlug) {
          window.location.reload();
        } else {
          const { slug } = await appState.getCurrentOrgUrl();
          window.location.href = `${slug}/dashboard`;
        }
      }
    } catch (e) {
      console.log(e);
      const isM3 = email.trim().endsWith('m3bygg.se') && !window.location.hostname.startsWith('m3bygg.');
      const isBrixly = email.trim().endsWith('brixly.se') && !window.location.hostname.startsWith('brixly.');
      this.setState({ btnLoginLoaderShow: false, errorShow: true, error: e.response?.data?.error, isM3, isBrixly });
    }
  }

  async signInWithMicrosoft() {
    const url = await ServiceAuth.getMicrosoftSignInUrl();
    window.location.href = url;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="app-login bt-w60">

        <Logo width="350px" type="logoWithTitle" />
        <div className="input-wrapper custom-input-wrapper">
          <AppLabel class="ar-label" headline={t('eMail','E-post')}>
            <input
              placeholder={t('eMail','E-post')}
              type="email"
              className="addSup-orgNo ar-text-field"
              name="email"
              ref={this.elEmail}
              value={this.props.email}
              onChange={(e) => this.props.setEmail(e.target.value)}
            />
          </AppLabel>
          <AppLabel class="ar-label" headline={t('password','Lösenord')}>
            <input
              placeholder={t('password','Lösenord')}
              className="addSup-orgNo ar-text-field"
              name="password"
              type="password"
              ref={this.elPassword}
            />
          </AppLabel>
              <div className="forgot-password-wrapper">
                <a className="forgot-password small" href="#" onClick={this.props.showFogotPassword}>{t('forgotPassword','Glömt lösenordet?')}</a>
              </div>
          <div className="btn-login-wrapper">
            <BtButton
              loaderShow={this.state.btnLoginLoaderShow}
              onClick={()=> this.login()}
            >
              {t('logIn', 'Logga in')}
            </BtButton>
          </div>
          <div className={styles.orContainer}>
            <span>{t('or', 'Eller')}</span>
            <img src={SignInWithMicrosoft} onClick={this.signInWithMicrosoft.bind(this)} style={{cursor:"pointer"}} />
          </div>
        </div>
        {this.state.errorShow && <div className={`error ${this.state.errorShow ? 'show' : ''}`}>
          {(this.state.error ?? '').startsWith('error.azureAdOnly') && (
            <p>{t('onlyMicrosoftLoginAvailable', 'Endast Microsoft-inloggning tillåten för detta konto')}</p>
          )}
          {!(this.state.error ?? '').startsWith('error.azureAdOnly') && (
            <div>
              <p>{t('wrongUserOrPassword', 'Felaktigt användarnamn eller lösenord')}</p>
              {this.state.isBrixly && (
                <p>
                  <Trans t={t} i18nKey="loginErrorWithBrixlyLink">Är du på rätt ställe? Brixlys Accurator-konto finns på <a href="https://brixly.accurator.se/">brixly.accurator.se</a>.</Trans>
                </p>
              )}
              {this.state.isM3 && (
                <p>
                  <Trans t={t} i18nKey="loginErrorWithM3ByggLink">Är du på rätt ställe? M3Byggs Accurator-konto finns på <a href="https://m3bygg.accurator.se/">m3bygg.accurator.se</a>.</Trans>
                </p>
              )}
            </div>
          )}
        </div>}
      </div>
    );
  }
}
export default withRouter(withTranslation('login')(AppLogin));
